export const UpdateBackgroundImage = 'UPDATE_BACKGROUND_IMAGE';
export const UpdateHeaderImage = 'UPDATE_HEADER_IMAGE';
export const UpdateAvatarImage = 'UPDATE_AVATAR_IMAGE';
export const UpdateGalleryImage = 'UPDATE_GALLERY_IMAGE';
export const AddGalleryImages = 'ADD_GALLERY_IMAGES';
export const RemoveGalleryImages = 'REMOVE_GALLERY_IMAGES';

